import { motion } from "framer-motion";

export default function Title({
  title,
  desc,
}: {
  title: string;
  desc: string;
}) {
  return (
    <motion.div
      className="mb-16 px-5 text-center"
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <h1 className="relative mb-4 inline-block text-3xl font-bold md:text-4xl">
        {title}
        <motion.div
          className="absolute -bottom-4 left-1/2 h-1 -translate-x-1/2 bg-primary-500"
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: "30%", opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        ></motion.div>
      </h1>
      <p className="mx-auto mt-6 max-w-3xl text-lg text-gray-600">{desc}</p>
    </motion.div>
  );
}
